// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionBtnList_layer1__YouD3 {
  display: grid;
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid var(--border-tertiary, #e3eaf2);
  background: var(--background-tertiary, #f7f9fc);
  margin-bottom: 8px;
  color: var(--text-secondary);
  height: -moz-fit-content;
  height: fit-content;
}

.ActionBtnList_actionBlock__7fgZp {
  display: flex;
  grid-column-start: 1;
  grid-column-end: span 2;
}

.ActionBtnList_layer2__TcMr6 {
  width: 100%;
}

.ActionBtnList_statusBlock__6r-ud {
  padding-right: 9px;
  cursor: pointer;
}

.ActionBtnList_status__3Fck7 > svg {
  height: 11px;
  width: 11px;
}

.ActionBtnList_watchNumber__dmiuE {
  padding: 0 5px;
}

.ActionBtnList_playBlock__3zDRy {
  text-align: right;
  display: inline-block;
  vertical-align: middle;
  min-width: 79px;
}

.ActionBtnList_playBlockL2__7r-SY > span {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.ActionBtnList_playBlockL2__7r-SY {
  padding-top: 8px;
}
.ActionBtnList_playBlockL2__7r-SY svg {
  height: 30px !important;
  width: 30px !important;
}
.ActionBtnList_playBlockL2__7r-SY svg path {
  height: 30px !important;
  width: 30px !important;
}

.ActionBtnList_pauseIcon__opszg svg {
  padding: 3px;
}

.ActionBtnList_actionName__8ag4i {
  color: var(--text-primary, #1f2023);
  font-size: 16px;
  min-height: 50px;
}

.ActionBtnList_playBlockL2Play__Zcptx {
  cursor: pointer;
}

.ActionBtnList_statusName__vdeSJ {
  width: 100%;
}

.ActionBtnList_failColor__NgWko {
  color: var(--text-danger);
}

.ActionBtnList_doneColor__\\+K8fG {
  color: #008000;
}

.ActionBtnList_inProgressColor__gBQrR {
  color: var(--text-link);
}

.ActionBtnList_showListLink__LvSV1 {
  cursor: pointer;
  color: var(--text-link);
}

.ActionBtnList_doubleColumn__NJqyG {
  grid-column-start: 1;
  grid-column-end: span 2;
  background-color: var(--border-tertiary, #e3eaf2);
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ActionBtnList/ActionBtnList.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,iDAAA;EACA,+CAAA;EACA,kBAAA;EACA,4BAAA;EACA,wBAAA;EAAA,mBAAA;AADD;;AAGA;EACC,aAAA;EACA,oBAAA;EACE,uBAAA;AAAH;;AAEA;EACC,WAAA;AACD;;AACA;EACC,kBAAA;EACA,eAAA;AAED;;AAAA;EACC,YAAA;EACA,WAAA;AAGD;;AADA;EACC,cAAA;AAID;;AAFA;EACC,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;AAKD;;AAHA;EACC,qBAAA;EACA,sBAAA;EACA,eAAA;AAMD;;AAJA;EAUC,gBAAA;AAFD;AAPC;EACC,uBAAA;EACA,sBAAA;AASF;AAPE;EACC,uBAAA;EACA,sBAAA;AASH;;AAFC;EACC,YAAA;AAKF;;AADA;EACC,mCAAA;EACA,eAAA;EACA,gBAAA;AAID;;AAFA;EACC,eAAA;AAKD;;AAHA;EACC,WAAA;AAMD;;AAJA;EACC,yBAAA;AAOD;;AALA;EACC,cAAA;AAQD;;AANA;EACC,uBAAA;AASD;;AAPA;EACC,eAAA;EACA,uBAAA;AAUD;;AARA;EACC,oBAAA;EACE,uBAAA;EACF,iDAAA;AAWD","sourcesContent":[".layer1 {\n\tdisplay: grid;\n\t// grid-template-columns: 1fr 1fr;\n\twidth: 100%;\n\tpadding: 8px;\n\n\tborder-radius: 8px;\n\tborder: 1px solid var(--border-tertiary, #e3eaf2);\n\tbackground: var(--background-tertiary, #f7f9fc);\n\tmargin-bottom: 8px;\n\tcolor: var(--text-secondary);\n\theight: fit-content;\n}\n.actionBlock{\n\tdisplay: flex;\n\tgrid-column-start: 1;\n  \tgrid-column-end: span 2;\n}\n.layer2{\n\twidth: calc(100%);\n}\n.statusBlock {\n\tpadding-right: 9px;\n\tcursor: pointer;\n}\n.status > svg {\n\theight: 11px;\n\twidth: 11px;\n}\n.watchNumber {\n\tpadding: 0 5px;\n}\n.playBlock {\n\ttext-align: right;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmin-width: 79px;\n}\n.playBlockL2 > span {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tcursor: pointer;\n}\n.playBlockL2 {\n\tsvg {\n\t\theight: 30px !important;\n\t\twidth: 30px !important;\n\n\t\tpath {\n\t\t\theight: 30px !important;\n\t\t\twidth: 30px !important;\n\t\t}\n\t}\n\tpadding-top: 8px;\n}\n\n.pauseIcon {\n\tsvg {\n\t\tpadding: 3px;\n\t}\n}\n\n.actionName {\n\tcolor: var(--text-primary, #1f2023);\n\tfont-size: 16px;\n\tmin-height: 50px;\n}\n.playBlockL2Play {\n\tcursor: pointer;\n}\n.statusName {\n\twidth: 100%;\n}\n.failColor {\n\tcolor: var(--text-danger);\n}\n.doneColor {\n\tcolor: #008000;\n}\n.inProgressColor {\n\tcolor: var(--text-link);\n}\n.showListLink{\n\tcursor: pointer;\n\tcolor: var(--text-link);\n}\n.doubleColumn{\n\tgrid-column-start: 1;\n  \tgrid-column-end: span 2;\n\tbackground-color: var(--border-tertiary, #e3eaf2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layer1": `ActionBtnList_layer1__YouD3`,
	"actionBlock": `ActionBtnList_actionBlock__7fgZp`,
	"layer2": `ActionBtnList_layer2__TcMr6`,
	"statusBlock": `ActionBtnList_statusBlock__6r-ud`,
	"status": `ActionBtnList_status__3Fck7`,
	"watchNumber": `ActionBtnList_watchNumber__dmiuE`,
	"playBlock": `ActionBtnList_playBlock__3zDRy`,
	"playBlockL2": `ActionBtnList_playBlockL2__7r-SY`,
	"pauseIcon": `ActionBtnList_pauseIcon__opszg`,
	"actionName": `ActionBtnList_actionName__8ag4i`,
	"playBlockL2Play": `ActionBtnList_playBlockL2Play__Zcptx`,
	"statusName": `ActionBtnList_statusName__vdeSJ`,
	"failColor": `ActionBtnList_failColor__NgWko`,
	"doneColor": `ActionBtnList_doneColor__+K8fG`,
	"inProgressColor": `ActionBtnList_inProgressColor__gBQrR`,
	"showListLink": `ActionBtnList_showListLink__LvSV1`,
	"doubleColumn": `ActionBtnList_doubleColumn__NJqyG`
};
export default ___CSS_LOADER_EXPORT___;
